import { lazy } from 'react';

const RELOAD_KEY = 'tinypdfs:chunk-reload';

function isStaleChunkError(error) {
  const message = String(error?.message || error || '');
  return error?.name === 'ChunkLoadError'
    || /Loading chunk .+ failed/i.test(message)
    || /Failed to fetch dynamically imported module/i.test(message)
    || /Importing a module script failed/i.test(message);
}

export default function lazyWithRetry(importer) {
  return lazy(async () => {
    try {
      const loaded = await importer();
      if (typeof window !== 'undefined') {
        window.sessionStorage.removeItem(RELOAD_KEY);
        const cleanUrl = new URL(window.location.href);
        if (cleanUrl.searchParams.has('_chunk_reload')) {
          cleanUrl.searchParams.delete('_chunk_reload');
          window.history.replaceState(window.history.state, '', cleanUrl.toString());
        }
      }
      return loaded;
    } catch (error) {
      if (typeof window !== 'undefined' && isStaleChunkError(error)) {
        const refreshUrl = new URL(window.location.href);
        refreshUrl.searchParams.delete('_chunk_reload');
        const routeKey = `${refreshUrl.pathname}${refreshUrl.search}`;
        if (window.sessionStorage.getItem(RELOAD_KEY) !== routeKey) {
          window.sessionStorage.setItem(RELOAD_KEY, routeKey);
          refreshUrl.searchParams.set('_chunk_reload', String(Date.now()));
          window.location.replace(refreshUrl.toString());
          return new Promise(() => {});
        }
      }
      throw error;
    }
  });
}
